// removed by extract-text-webpack-plugin
module.exports = {"mobileNav":"src-components-MobileNav----mobile-nav-module---mobileNav---3k_s_","close":"src-components-MobileNav----mobile-nav-module---close---2DJgu","closeBarA":"src-components-MobileNav----mobile-nav-module---closeBarA---ncx2c","closeBarB":"src-components-MobileNav----mobile-nav-module---closeBarB---1MWwG","navItems":"src-components-MobileNav----mobile-nav-module---navItems---L2rXV","link":"src-components-MobileNav----mobile-nav-module---link---1Ysze"};


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/mobile-nav.module.scss
// module id = 320
// module chunks = 168707334958949